module.exports = __webpack_public_path__ + "img/ywyk-instructions07.b3bfb55a.jpg";